import React, { Component, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import Cart from '../pages/cart/Cart';

export class ModalTest extends Component {

  render() {
    if (!this.props.show) {
        return null;
    };
      return (
          <>
              {/* <Modal show={this.props.show}>
                  <Modal.Header closeButton>
                      <Modal.Title>Modal heading</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
                  <Modal.Footer>
                      <Button variant="secondary" onClick={this.props.toggleIsActive}>
                          Close
                      </Button>
                      <Button variant="primary" onClick={this.props.toggleIsActive}>
                          Save Changes
                      </Button>
                  </Modal.Footer>
              </Modal> */}

            <Modal show={this.props.show}  centered fullscreen  >
              <Modal.Body>
                  <div className="container relative">
                    <span className="mdClose">k</span>
                  </div>
                  <Cart />
              </Modal.Body>
            </Modal>
          </>
      )
  }
}
